import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadSamples} from '../actions/samples.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class SampleGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkSample()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkSample(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectSamplesLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadSamples());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
